import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import AutosSearch from 'components/AutosSearch';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { TravelArrangerUsersAllowed } from 'services/userService';

type Props = {
  allowedTravelers: TravelArrangerUsersAllowed[];
  isLoadingAllowedTravelers: boolean;
  branchCompanies?: GetAllBillingCompanyResponse[];
  isLoadingBranchCompanies: boolean;
};

const AutosSearchContainer = ({
  allowedTravelers,
  isLoadingAllowedTravelers,
  branchCompanies,
  isLoadingBranchCompanies,
}: Props) => {
  const {
    traveler,
    pickUpPoint,
    dropOffPoint,
    pickUpDate,
    dropOffDate,
    pickUpTime,
    dropOffTime,
    diffDropOff,
    branchCompany,
  } = useSelector((state: RootState) => state.autos);

  return (
    <AutosSearch
      defaultTraveler={traveler}
      defaultPickUpPoint={pickUpPoint}
      defaultDropOffPoint={dropOffPoint}
      defaultPickUpDate={pickUpDate ? new Date(pickUpDate) : undefined}
      defaultDropOffDate={dropOffDate ? new Date(dropOffDate) : undefined}
      defaultPickUpTime={pickUpTime}
      defaultDropOffTime={dropOffTime}
      defaultDiffDropOff={diffDropOff}
      allowedTravelers={allowedTravelers}
      isLoadingAllowedTravelers={isLoadingAllowedTravelers}
      branchCompanies={branchCompanies}
      isLoadingBranchCompanies={isLoadingBranchCompanies}
      defaultBranchCompany={branchCompany}
    />
  );
};
export default AutosSearchContainer;
